import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';

import { Navigation } from './navigation.component';
import { NavigationItem } from './navigation-item.component';
import { NavigationMenu } from './navigation-menu.component';
import { MobileNavigation } from './mobile-navigation.component';

export {
  Navigation,
  NavigationItem,
  NavigationMenu,
  MobileNavigation,
};

@NgModule({
  declarations: [
    Navigation,
    NavigationItem,
    NavigationMenu,
    MobileNavigation,
  ],
  imports: [
    CommonModule,
    IconModule,
    ButtonModule,
  ],
  exports: [
    Navigation,
    NavigationItem,
    NavigationMenu,
    MobileNavigation,
  ]
})
export class NavigationModule { }
